import {  Spinner, Input, RadioGroup, SingleSelectInput } from '../common/atoms';
import { useEffect, useState } from 'react';
import { DatePicker } from '../tailwind/molecules'
import { CheckBox } from '../tailwind/molecules';
import moment from 'moment';
import { indian_flag } from '../../assets/images';
import { Form, Select} from 'antd';
import { SALES_ROLE } from '../../constants/overview';
import { employeeDataApi } from '../../services';
import { handleAppError } from '../handlers';
import { dsButtonPrimary, joinButtonClasses } from '../../utils/buttonStyles';
const FormItem = Form.Item;

const AddSingle = (props) => {
  const [state, setState] = useState({
      isLoading: false,
      selected_business_unit: '',
      startDate: moment().add(0,'days'),
      endDate: moment().add(29,'days'),

      details: { 
          name: '',
          email: '',
          mobile_number: '',
          date_of_birth: '',
          gender: 'Male',
          aadhaar_card_no: '',
          job_required: [],
          address:  '',
          date_of_appointment: '',
          date_of_joining: '',
          other_details: '',
          business_unit: [],
          entity_name : '',
          grade: ''
      },
      business_units: [],
      entities: [],
      grades: [],
      errors : {}
  })

  useEffect(() => {
    setState((prev) => {return{...prev,...{isLoading: true}}})
    onMount()
    fetchEntityDetails()
    fetchGradesDetails()
  },[])

  const onMount = () => {
    window.axios.get(window.API_URL + 'corporate/appointment-requests/company_business_units?company_id=' + sessionStorage.getItem('company_id'))
      .then(function (response) {
        let subState = { business_units: response.data["business_units"], isLoading: false}
        setState((prev) => { return{...prev,...subState}})
      })
      .catch(function (error) {
        setState((prev) => {return{...prev, ...{isLoading: false}}})
      })
  }

  const setSubState = (newState) => {
    setState(prevState => { return {...prevState, ...newState } })
  }

  const changeHandler = (name, value) =>{
    if(name == 'entity_name'){
      const entityValue = state.entities.find((option) => option.name === value)?.id
      setSubState({details: { ...state.details, entity_id: entityValue, [name]: value }, errors : {} }) 
    }else{
      setSubState({details: { ...state.details, [name]: value }, errors : {} })
    }
  }

  const fetchEntityDetails = () => {
    const sponsor_id = sessionStorage.getItem('company_id');
    employeeDataApi.fetch_entity_details(
      { id: sponsor_id },
      (res) => {
        const data = res.data.entities || [];
        setSubState({ entities: data, isLoading: false, errors: {} });
      },
      (err) => handleAppError(err)
    );
  };

  const fetchGradesDetails = () => {  
    employeeDataApi.company_grades(
      { companyId: sessionStorage.getItem('company_id') },
      (res) => {
        let data = res.data.grades || []
        data.push('UNGRADED').uniq
        setSubState({ grades: data, isLoading: false, errors: {} });
      },
      (err) => handleAppError(err)
    )
  }

  const addFormDetails = () => {
    if(validate(state.details)){
      setState((prev) => {return{...prev, ...{isLoading: true}}})
      let details = state.details
      if (details.email === ''){
        details.email = null
      }
      let options = {appointment_request: details, entity_id: details?.entity_id, type: 'PpmcAppointment', company_id: sessionStorage.getItem('company_id')}
      window.axios.post(window.API_URL + 'corporate/appointment-requests', options)
      .then(function (response) {
          setState((prev) => {return{...prev, ...{isLoading: false}}})
          props.onFormSubmitSuccess(response)
      })
      .catch(function (error) {
          setState((prev) => {return{...prev, ...{isLoading: false}}})
          props.onFormSubmitFail(error)
      })
    }  
  }

  const validate = (formValues) =>{
    let newError = {}
    if (!formValues.name) {
      newError = {...newError, name : 'Name should not be empty'}
    }
    else if (!formValues.date_of_birth){
      newError = {...newError, date_of_birth : 'Date of birth should not be empty and Invalid'}
    }
    else if (disableDateOfBirth(formValues.date_of_birth)){
        newError = {...newError, date_of_birth : 'Please Enter a correct Date of Birth'}
    }
    else if (!formValues.mobile_number){
      newError = {...newError, mobile_number : 'Mobile Number Should not be empty'}
    }
    else if (!formValues.mobile_number.match(/^[6-9][0-9]{9}$/)){
      newError = {...newError, mobile_number : 'Mobile number should be 10 digits and starts with [6-9]'}
    }
    else if (formValues.date_of_appointment) {
      if(disabledDate(formValues.date_of_appointment)){
        newError = {...newError, date_of_appointment : `enter date greater than ${state.startDate.format('DD-MM-YYYY')} and less than ${state.endDate.format('DD-MM-YYYY')}`}
      }
      else if(formValues.date_of_joining && greaterThanAppt(formValues.date_of_joining, formValues.date_of_appointment)){
        newError = {...newError, date_of_joining : 'should be greater than Date of appointment'}
      }
    }
    else if (formValues.date_of_joining && disableJoiningDate(formValues.date_of_joining)) {
        newError = {...newError, date_of_joining : "should be greater than today's date"}
    }
    else if (!formValues.entity_name && entityNames.length > 0) {
      newError = {...newError, entity_name : 'Field is mandatory'}
    } 
   setSubState({errors : newError})
    return Object.keys(newError || {}).length === 0
  }

  const disableJoiningDate = (current) => {
    current = moment(current, 'DD-MM-YYYY')
    if(current >= moment().add(0, 'day')) return false;
    else return true;
  }

  const greaterThanAppt = (current, limit) => {
    if(moment(current, 'DD-MM-YYYY') <= moment(limit, 'DD-MM-YYYY')) return true;
    else return false;
  }

  const disableDateOfBirth = (current) => {
    if(moment().subtract(1, 'day') < moment(current, 'DD-MM-YYYY')){
      return true;
    }else{
      return false;
    }
  }

  const disabledDate = (current) => {
    const { startDate, endDate } = state;
    if (moment(current, 'DD-MM-YYYY') >= startDate && moment(current, 'DD-MM-YYYY')<= endDate) {
      return false;
    }
    else {
     return true;
    }
  }

  const handleSelectBusinessUnitChange = (e) => {
    let subState = {selected_business_unit: e};
    setState((prev) => {return{...prev,...subState}})
    changeHandler('business_unit', e);
  }

  const handleShowBusinessUnits = () => {
    const formItemLayout = null;
    let business_units = state.business_units
    if(business_units.length > 0) {
      return(
        <div>
          <h1 className='text-gray-500 text-xs tracking-widest font-semibold leading-3 mt-6'>BUSINESS UNITS</h1>
          <FormItem {...formItemLayout}>
            <Select
              showSearch={true}
              style={{ width: '100%', marginTop: 8, backgroundColor: '#fff'}}
              placeholder="Select business unit from the list"
              onChange={(e)=> handleSelectBusinessUnitChange(e)}
              size='large'              
            >
              {
                business_units.map(function(bu, i) {
                    return (
                        <Option value={bu} key={i}>{bu}</Option>
                    )
                })
              }
            </Select>
          </FormItem>  
        </div>
      )  
    }
    else{
      return(null)
    }
  }

  const plainOptions = (props.sponsorId !== 1125 ? [{value: 'Desk Job' , text: 'Desk Job'}, {value: 'Field Job' , text: 'Field Job'}, {value: 'Warehouse' , text: 'Warehouse'}, {value: 'Shop Floor Job' , text: 'Shop Floor Job'}, {value: 'Manufacturing Job' , text: 'Manufacturing Job'}] : [{value: 'Desk Job' , text: 'Desk Job'}, {value: 'Field Job' , text: 'Field Job'}, {value: 'Manufacturing Job' , text: 'Manufacturing Job'}]) ;
  const addIndividualLoading   = state.isLoading
  const entityNames = state.entities.map((item) => item.name).sort()

  return(
    <Spinner isLoading={addIndividualLoading}>
      <div className='-m-6 p-6' style={{background: '#F9FAFB'}}>
        <Input
           label='EMPLOYEE FULL NAME' 
           name= 'name'
           labelClasses='text-xs font-semibold tracking-widest leading-3 text-gray-500 mb-3'
           inputClasses='text-base font-semibold text-gray-700 leading-4'
           value={state.details.name}
           error={state.errors.name}
           style={{background: 'white'}}
           placeholder='Add employee name here'
           onChange = {(e) => {
             let {name , value} = e.target
             var letters = /^[a-zA-Z\s]*$/;
             if(!value.match(letters)) return false
             value = (value === ' ' ? value.trim() : value )
             changeHandler(name, value)
            }}
        />
         <div className='mt-6 flex flex-row'>
          <RadioGroup 
            title='GENDER' 
            radioList={['Male', 'Female']} 
            titleClasses='text-xs mb-3 font-semibold tracking-widest leading-3 text-gray-500 mb-3' 
            radioInputClasses='h-5 w-5 focus:ring-0 focus:ring-white' 
            labelClases='text-gray-700 text-base leading-4 ml-3 font-semibold font-proxima-nova' 
            radioClasses='grid-cols-4'
            error={state.errors.gender}  
            name='gender' 
            value={state.details.gender} 
            handler={(e) => {
              let {name,value} = e.target
              changeHandler(name, value)
            }} 
          />
          </div>
           <DatePicker
             labelClasses='text-xs font-semibold tracking-widest leading-3 mb-3 mt-6'
             label='DOB'
             value = {state.details.date_of_birth}
             inputClasses='text-gray-700 font-semibold text-base leading-4 w-full h-14'
             classes ='mt-5'
             color='#6B7280'
             size='12px'
             error={state.errors.date_of_birth}
             handler={(value) => {
               let name='date_of_birth'
               changeHandler(name, value)
             }} 
           />
           <div>
             <div className='text-gray-500 text-xs tracking-wide leading-3 font-semibold mt-6' >MOBILE NUMBER</div>
             <div className='flex flex-row mt-3 w-full'>
              <div className='flex flex-row bg-white mr-3 px-3 border border-gray-200 rounded-md h-14'>
                <img src={indian_flag} className='mr-1 py-5' />
                <div className='text-gray-500 py-4 font-semibold mt-0.5'>IND</div>
              </div>
                <Input
                  name= 'mobile_number'
                  labelClasses='text-xs font-semibold tracking-widest leading-3 text-gray-500 mb-3'
                  inputClasses='text-base font-semibold text-gray-700 leading-4'
                  placeholder='Eg: 9876 543 210'
                  value={state.details.mobile_number}
                  error={state.errors.mobile_number}
                  style={{background: 'white'}}
                  classes='w-full'
                  onChange = {(e) => {
                  let {name , value} = e.target
                  var letters = /^[0-9]*$/;
                  if(!value.match(letters)) return false
                  value = (value === ' ' ? value.trim() : value )
                  changeHandler(name, value)
                  }}
                />
             </div>
           </div>
           <div>
            <Input
                  label='EMAIL'
                  name= 'email'
                  labelClasses='text-xs font-semibold tracking-widest leading-3 text-gray-500 mb-3 mt-6'
                  inputClasses='text-base font-semibold text-gray-700 leading-4'
                  placeholder='Add employee email here'
                  value={state.details.email}
                  error={state.errors.email}
                  style={{background: 'white'}}
                  onChange = {(e) => {
                  let {name , value} = e.target
                  value = (value === ' ' ? value.trim() : value )
                  changeHandler(name, value)
                  }}
            />
            <h4 className='text-xs tracking-wide leading-3 mt-2' style={{color: '#6B7280'}}>In case the employee doesn't have any email leave it blank, all mailers will be sent to respective HR who added the details.</h4>
            <div className='mt-6'>
              <CheckBox 
                name='job_required' 
                label='EMPLOYEE JOB TYPE' 
                isMulti={true} 
                selectedValues={state.details.job_required} 
                inputs={plainOptions} 
                labelClasses='text-gray-500 text-xs tracking-wide leading-3' 
                error={state.errors.job_required}
                inputsClasses='grid grid-rows-2 grid-flow-col'
                onChangeHandler={(e) => {
                  let {name,value} = e
                  changeHandler(name, value)
                }}  
              />
            </div>
            {entityNames.length > 0 ?
              <div className='mt-6'>
                <SingleSelectInput 
                  onChangeHandler={(event) => {
                    let {name,value} = event
                    changeHandler(name, value)
                  }}  
                  value={state.details.entity_name || ''}
                  data={entityNames}
                  search={true}
                  name='entity_name'
                  placeholder='Select' 
                  label='ENTITY NAME' 
                  labelClasses='text-xs font-semibold tracking-widest leading-3 text-gray-500 mb-3 mt-6'
                  listClasses='z-20'
                  listItemClasses='capitalize p-6 pb-5'
                  bgColor='bg-white capitalize'
                  disable={SALES_ROLE === "sales"}
                  placeholderClasses='h-6'
                  error={state.errors.entity_name}
                />
              </div>
              : null
            }
            <div>
            <div className='mt-6'>
              <SingleSelectInput 
                onChangeHandler={(event) => {
                  let {name,value} = event
                  changeHandler(name, value)
                }}
                value={state.details.grade || 'UNGRADED'}
                data={state.grades}
                name='grade'
                placeholder='Select' 
                label='GRADE' 
                labelClasses='text-xs font-semibold tracking-widest leading-3 text-gray-500 mb-3 mt-6'
                listClasses='z-20'
                listItemClasses='capitalize p-6 pb-5'
                bgColor='bg-white capitalize'
                disable={state.grades.length == 0}
                placeholderClasses='h-6'
              />
            </div>
            <DatePicker
             labelClasses='text-xs font-semibold tracking-widest leading-3 mb-3 mt-6'
             label='APPOINTMENT DATE'
             value = {state.details.date_of_appointment}
             inputClasses='text-gray-700 font-semibold text-base leading-4 w-full h-14'
             classes ='mt-5'
             color='#6B7280'
             size='12px'
             error={state.errors.date_of_appointment}
             handler={(value) => {
               let name='date_of_appointment'
               changeHandler(name, value)
             }} 
           />
            </div>
            <div>
              <DatePicker
              labelClasses='text-xs font-semibold tracking-widest leading-3 mb-3 mt-6'
              label='DATE OF JOINING (OPTIONAL)'
              value = {state.details.date_of_joining}
              inputClasses='text-gray-700 font-semibold text-base leading-4 w-full h-14'
              classes ='mt-5'
              color='#6B7280'
              size='12px'
              error={state.errors.date_of_joining}
              handler={(value) => {
                let name='date_of_joining'
                changeHandler(name, value)
              }} 
            />
            </div>
            {handleShowBusinessUnits()}
            <div>
              <Input
                  label='AADHAR CARD NO (OPTIONAL)'
                  name= 'aadhaar_card_no'
                  labelClasses='text-xs font-semibold tracking-widest leading-3 text-gray-500 mb-3 mt-6'
                  inputClasses='text-base font-semibold text-gray-700 leading-4'
                  placeholder='1234-5678-9012'
                  value={state.details.aadhaar_card_no}
                  error={state.errors.aadhaar_card_no}
                  style={{background: 'white'}}
                  onChange = {(e) => {
                  let {name , value} = e.target
                  var letters = /^[0-9]*$/;
                  if(!value.match(letters)) return false
                  value = (value === ' ' ? value.trim() : value )
                  changeHandler(name, value)
                  }}
              />
            </div>
            <div>
              <Input
                  label='EMPLOYEE ADDRESS (OPTIONAL)'
                  name= 'address'
                  labelClasses='text-xs font-semibold tracking-widest leading-3 text-gray-500 mb-3 mt-6'
                  inputClasses='text-base font-semibold text-gray-700 leading-4'
                  placeholder='Add employee address here'
                  value={state.details.address}
                  error={state.errors.address}
                  style={{background: 'white'}}
                  onChange = {(e) => {
                  let {name , value} = e.target
                  value = (value === ' ' ? value.trim() : value )
                  changeHandler(name, value)
                  }}
              />
            </div>
            <div>
              <Input
                  label='OTHER DETAILS (OPTIONAL)'
                  name= 'other_details'
                  labelClasses='text-xs font-semibold tracking-widest leading-3 text-gray-500 mb-3 mt-6'
                  inputClasses='text-base font-semibold text-gray-700 leading-4'
                  value={state.details.other_details}
                  error={state.errors.other_details}
                  style={{background: 'white'}}
                  onChange = {(e) => {
                  let {name , value} = e.target
                  value = (value === ' ' ? value.trim() : value )
                  changeHandler(name, value)
                  }}
              />
            </div>
            <div className='sticky bottom-0 z-10 py-2 px-4 bg-white -mx-6 my-4'>
              <button
                type='submit'
                onClick={addFormDetails}
                disabled={SALES_ROLE === "sales"}
                className={joinButtonClasses(dsButtonPrimary, 'mt-6 h-14 w-full px-6', SALES_ROLE === 'sales' && 'cursor-not-allowed')}
              >
                Add employee for checkups
              </button>
            </div>
           
           </div>
      </div>
      
    </Spinner>
  )


}


export default AddSingle;
